// src/components/EnrichmentTypeSelector.tsx
import React from 'react';
import { Users, Building2, ArrowRight } from 'lucide-react';
import './EnrichmentTypeSelector.css';

interface EnrichmentTypeSelectorProps {
  onSelectType: (type: 'contact' | 'company') => void;
}

const EnrichmentTypeSelector: React.FC<EnrichmentTypeSelectorProps> = ({ onSelectType }) => {
  return (
    <div className="enrichment-type-selector">
      <div className="enrichment-type-header">
        <h2>Choose Enrichment Type</h2>
        <p>Select the type of data you want to enrich.</p>
      </div>
      
      <div className="enrichment-type-options">
        <div 
          className="enrichment-type-card contact-card"
          onClick={() => onSelectType('contact')}
        >
          <div className="card-icon">
            <Users size={32} />
          </div>
          <div className="card-content">
            <h3>Contact Enrichment</h3>
            <p>Enrich contact data with LinkedIn profiles, email addresses, and phone numbers.</p>
          </div>
          <div className="card-arrow">
            <ArrowRight size={20} />
          </div>
        </div>

        <div 
          className="enrichment-type-card company-card"
          onClick={() => onSelectType('company')}
        >
          <div className="card-icon">
            <Building2 size={32} />
          </div>
          <div className="card-content">
            <h3>Company Enrichment</h3>
            <p>Enrich company data with detailed company information and metrics.</p>
          </div>
          <div className="card-arrow">
            <ArrowRight size={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrichmentTypeSelector;

